import { WCCContentBlock } from '../blocks/block/block';
import { IWCCContentBlockSplitOptions } from '../blocks/block/block.interfaces';
import { WCCContentTextBlock } from '../blocks/text/text';
import WCCContentContext from '../context';
import WCCContentDocument from '../document';
import WCCContentRule from './base';

export default abstract class WCCContentPatternRule extends WCCContentRule {
    protected abstract pattern: RegExp
    protected prefix?: RegExp
    protected postfix?: RegExp

    parse(document: WCCContentDocument, context: WCCContentContext) {
        const options: IWCCContentBlockSplitOptions = {
            prefix: this.prefix,
            pattern: this.pattern,
            postfix: this.postfix
        }

        return document.replace(options, content => this.process(<RegExpMatchArray>this.pattern.exec(content), context) ?? new WCCContentTextBlock(content));
    }

    protected abstract process(match: RegExpMatchArray, context: WCCContentContext): WCCContentBlock | undefined
}